import { render, staticRenderFns } from "./mallApply.vue?vue&type=template&id=0c9f1110&scoped=true&"
import script from "./mallApply.vue?vue&type=script&lang=js&"
export * from "./mallApply.vue?vue&type=script&lang=js&"
import style0 from "./mallApply.vue?vue&type=style&index=0&id=0c9f1110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f1110",
  null
  
)

export default component.exports